/**
 * @generated SignedSource<<c94c3f7a76f8371f5cb62396b720ee7a>>
 * @relayHash 814697115f3f596cbb9c38ce14be1f85
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38

import type { ConcreteRequest } from 'relay-runtime';
export type useViewPdfDataQuery$variables = {
  contentId?: string | null;
  contentStatus?: ReadonlyArray<string | null> | null;
  postingDay?: string | null;
  spaceKey?: string | null;
  title?: string | null;
  type?: string | null;
};
export type useViewPdfDataQuery$data = {
  readonly content: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly attachments: {
          readonly nodes: ReadonlyArray<{
            readonly extensions: ReadonlyArray<{
              readonly key: string | null;
              readonly value: string | null;
            } | null> | null;
            readonly title: string | null;
          } | null> | null;
        } | null;
        readonly id: string | null;
      } | null;
    } | null> | null;
  } | null;
};
export type useViewPdfDataQuery = {
  response: useViewPdfDataQuery$data;
  variables: useViewPdfDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentStatus"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "postingDay"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "title"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v6 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  {
    "kind": "Variable",
    "name": "postingDay",
    "variableName": "postingDay"
  },
  {
    "kind": "Variable",
    "name": "spaceKey",
    "variableName": "spaceKey"
  },
  {
    "kind": "Variable",
    "name": "status",
    "variableName": "contentStatus"
  },
  {
    "kind": "Variable",
    "name": "title",
    "variableName": "title"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 250
  }
],
v9 = {
  "kind": "ScalarField",
  "name": "title"
},
v10 = {
  "concreteType": "KeyValueHierarchyMap",
  "kind": "LinkedField",
  "name": "extensions",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "value"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useViewPdfDataQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "PaginatedContentList",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "attachments(first:250)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "useViewPdfDataQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "ContentEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "Content",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "args": (v8/*: any*/),
                    "concreteType": "PaginatedContentList",
                    "kind": "LinkedField",
                    "name": "attachments",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                          (v9/*: any*/),
                          (v10/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "attachments(first:250)"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "814697115f3f596cbb9c38ce14be1f85",
    "id": "fb4b2b513a3e28c226362fa46e7d11cc5508513505b03509f58942665c918c38",
    "metadata": {},
    "name": "useViewPdfDataQuery",
    "operationKind": "query",
    "text": "query useViewPdfDataQuery($contentId:ID,$contentStatus:[String],$spaceKey:String,$title:String,$type:String,$postingDay:String){content(id:$contentId,status:$contentStatus,spaceKey:$spaceKey,title:$title,type:$type,postingDay:$postingDay){edges{node{id,attachments(first:250){nodes{title,extensions{key,value},id}}}}}}"
  }
};
})();

(node as any).hash = "20d975cc714dfdf1087101ddcb9c164b";

export default node;
